import { gql } from '@apollo/client';

export default gql`
  mutation NotifyLiftAndShift($input: NotifyLiftAndShiftInput!) {
    notifyLiftAndShift(input: $input)
  }
`;
